import { configureOmiseSDK } from "./configureOmise";

export class CreditCardFlow {
	paymentAmount = null;
	data = null;
	searchParams = null;

	initializeEpayment = async () => {
		throw new Error("initializeEpayment is required");
	};

	createOmiseCharge = async () => {
		throw new Error("initializeEpayment is required");
	};

	constructor({ paymentAmount, data, initializeEpayment, createOmiseCharge, searchParams }) {
		this.paymentAmount = paymentAmount;
		this.data = data;
		this.searchParams = searchParams;

		if (!initializeEpayment) {
			throw new Error("initializeEpayment is required");
		}
		this.initializeEpayment = initializeEpayment;

		if (!createOmiseCharge) {
			throw new Error("createOmiseCharge is required");
		}
		this.createOmiseCharge = createOmiseCharge;
		configureOmiseSDK();
	}

	async processPayment() {
		const epaymentPayload = {
			...this.data,
			omiseToken: "",
			omiseSource: "",
			payment_method: "omise_credit_card",
		};

		const epaymentResponse = await this.initializeEpayment(epaymentPayload);
		if (!epaymentResponse.status == 1) {
			throw new Error("Unexpected error while creating payment record, expecting 1");
		}

		const nonce = await new Promise((resolve, reject) => {
			window.OmiseCard.open({
				amount: this.paymentAmount * 100,
				currency: "SGD",
				defaultPaymentMethod: "credit_card",
				onCreateTokenSuccess: (nonce) => {
					resolve(nonce);
				},
				onCreateTokenFailure: (error) => {
					reject(error);
				},
				onFormClosed: () => {
					reject(new Error("Payment Form Cancelled"));
				},
			});
		});

		const chargeData = {
			omiseToken: "",
			omiseSource: "",
			payment_id: epaymentResponse.data.payment_id,
			payment_mode: "omise_credit_card",
		};

		if (nonce.startsWith("tokn_")) {
			chargeData.omiseToken = nonce;
		} else {
			chargeData.omiseSource = nonce;
		}

		console.log("createOmiseCharge", chargeData);

		return this.createOmiseCharge(chargeData).then((d) => {
			if (d.status == 2) {
				/**
				 * redirect rul
				 */
				const url = new URL(d.url);
				// const searchParams = new URLSearchParams(url.search)
				// for (let entry of this.searchParams.entries()) {
				// 	if (searchParams.has(entry[0])) {
				// 		// skip is has duplicated key
				// 		continue
				// 	}
				// 	searchParams.set(entry[0], entry[1])
				// }
				// url.search = searchParams.toString()
				window.location.href = url.toString();
			}
		});
	}
}
